/**
 * Init Password Toggle
 */
window.initPasswordToggle = function () {
    const passwordToggle = $('.password-toggle');

    // password toggle
    if (passwordToggle.length) {
        passwordToggle.on('click', function () {
            const toggleElement = $(this);
            if (toggleElement.closest('label').children('input').length) {
                const inputElement = toggleElement.closest('label').children('input');
                const inputType = inputElement.attr('type');
                if (inputType === 'password') {
                    inputElement.attr('type', 'text');
                } else {
                    inputElement.attr('type', 'password');
                }
            }
        });
    }
};